import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { QuestionsModule } from '../questions/questions.module';
import { SharedModule } from '../shared/shared.module';
import { ApgLeadGenCompleteComponent } from './apg-lead-gen-complete/apg-lead-gen-complete.component';
import { ApgLeadGenPageComponent } from './apg-lead-gen-page/apg-lead-gen-page.component';
import { ApgLeadGenComponent } from './apg-lead-gen.component';



@NgModule({
  declarations: [
    ApgLeadGenComponent,
    ApgLeadGenCompleteComponent,
    ApgLeadGenPageComponent
  ],
  exports: [
    ApgLeadGenComponent
  ],
  providers: [
    CurrencyPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    DirectivesModule,
    FormsModule,
    IonicModule,
    NgxSliderModule,
    CurrencyMaskModule,
    QuestionsModule
  ]
})
export class ApgLeadGenModule { }
